import { render, staticRenderFns } from "./task-wise-report.vue?vue&type=template&id=3677087e&scoped=true&"
import script from "./task-wise-report.vue?vue&type=script&lang=js&"
export * from "./task-wise-report.vue?vue&type=script&lang=js&"
import style0 from "./task-wise-report.vue?vue&type=style&index=0&id=3677087e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3677087e",
  null
  
)

export default component.exports